import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSwitchComponent } from './custom-switch.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';



@NgModule({
  declarations: [
    CustomSwitchComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule
  ],
  exports: [
    CustomSwitchComponent
  ]
})
export class CustomSwitchModule { }
